import React, { useEffect, useRef } from "react";
import { loadTinyMCEScript } from "./LoadTinyMCEScript";

interface BeelditWYSIWYGInputProps {
  value: string;
  onChange: (content: string) => void;
}

declare global {
  interface Window {
    tinymce: any;
  }
}

const BeelditWYSIWYGInput: React.FC<BeelditWYSIWYGInputProps> = ({ value, onChange }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const editorIdRef = useRef("beeldit-editor-" + Math.random().toString(36).substring(2, 15));
  const editorId = editorIdRef.current;

  useEffect(() => {
    let isMounted = true;
    loadTinyMCEScript()
      .then(() => {
        if (!isMounted || !window.tinymce) return;
        window.tinymce.init({
          selector: `#${editorId}`,
          height: 300,
          menubar: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            // "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            // "fullscreen",
            // "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount"
          ],
          toolbar:
            "undo redo | blocks  | code | formatselect " +
            "bold italic backcolor | alignleft aligncenter " +
            "alignright alignjustify | table | bullist numlist outdent indent | " +
            "removeformat | fontsizeselect fontselect | media | wordcount",
          // "undo redo | blocks fontfamily fontsize | code | formatselect " +
          // "bold italic backcolor | alignleft aligncenter " +
          // "alignright alignjustify | table | bullist numlist outdent indent | " +
          // "removeformat | fontsizeselect fontselect | insertdatetime | media | help",
          paste_as_text: true,
          valid_elements: "@[style],p,br,strong/b,em/i,ul,ol,li,a[href|target]",
          invalid_attributes: "data-path-to-node, id, class, style",
          removeformat: [
            {
              selector: "b,strong,em,i,font,u,s,strike",
              remove: "all",
              split: true,
              expand: false,
              block_expand: true,
              deep: true
            },
            {
              selector: "p,span,h1,h2,h3,h4,h5,h6,div",
              attributes: ["style", "class", "id", "data-path-to-node"],
              remove: "empty",
              split: true,
              expand: false,
              deep: true
            },
            {
              selector: "table,tr,td,th",
              attributes: ["class", "id", "data-path-to-node"],
              split: false,
              expand: false,
              deep: true
            }
          ],
          setup: (editor: any) => {
            editor.on("init", () => editor.setContent(value || ""));

            // Remove the data-path-to-node attribute from the content if it's been missed
            editor.on("GetContent", (e: any) => {
              if (e.content) e.content = e.content.replace(/\sdata-path-to-node="[^"]*"/g, "");
            });

            editor.on("change keyup input", () => onChange(editor.getContent()));
          }
        });
      })
      .catch(console.error);

    return () => {
      isMounted = false;
      // destruyo el editor asociado al ID
      window.tinymce?.remove(`#${editorId}`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // solo al montar

  return <textarea id={editorId} ref={textareaRef} />;
};

export default BeelditWYSIWYGInput;
